import { DateTime } from "luxon";
import React from "react";
import { PreloadedQuery, graphql, usePreloadedQuery } from "react-relay";

import { WidgetTeamSchedule } from "widgets";
import { WidgetTeamScheduleMockPreviewQuery } from "./__generated__/WidgetTeamScheduleMockPreviewQuery.graphql";

export const WIDGET_TEAM_SCHEDULE_MOCK_PREVIEW_QUERY = graphql`
  query WidgetTeamScheduleMockPreviewQuery(
    $storecastId: ID!
    $input: PreviewWidgetTeamScheduleInput!
  ) @raw_response_type {
    dashboard(id: $storecastId) @required(action: THROW) {
      previewWidgetTeamSchedule(input: $input) {
        ...WidgetTeamSchedule_widget
      }
    }
  }
`;
export function WidgetTeamScheduleMockPreview(props: {
  queryRef: PreloadedQuery<WidgetTeamScheduleMockPreviewQuery>;
}) {
  const data = usePreloadedQuery(
    WIDGET_TEAM_SCHEDULE_MOCK_PREVIEW_QUERY,
    props.queryRef
  );

  return (
    <WidgetTeamSchedule
      mode="IDLE"
      widget={data.dashboard.previewWidgetTeamSchedule}
      interactive={false}
      storecastId=""
      now={DateTime.now().set({ hour: 9, minute: 0 })}
    />
  );
}
